import { render, staticRenderFns } from "./ConsumerUsers.vue?vue&type=template&id=065af0e7&scoped=true&"
import script from "./ConsumerUsers.vue?vue&type=script&lang=js&"
export * from "./ConsumerUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065af0e7",
  null
  
)

export default component.exports